/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ActionType {
  SendEmail = 'send_email',
  ContinueExecution = 'continue_execution'
}
